import React, {useState} from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyUsuarios } from '../../components/Usuarios/ContentBodyUsuarios'
import '../Pacientes/Pacientes.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const Usuarios = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();


    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='Usuarios'  >
                <div className='headerUsuarios'>
                    <HeaderHome 
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className="bodyUsuarios">
                    <ContentBodyUsuarios
                    chageMenuLateralAux={chageMenuLateralAux}
                    MenuLateralAux={MenuLateralAux}
                    />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
